const productOrderStatusTypes = {
    Booked: 1,
    Installed: 2,
    Cancelled: 3,
    Disconnect: 4
};

const productOrderStatusTypeNames = {
    [productOrderStatusTypes.Booked]: "Booked",
    [productOrderStatusTypes.Installed]: "Confirmed",
    [productOrderStatusTypes.Cancelled]: "Cancelled",
    [productOrderStatusTypes.Disconnect]: "Disconnect",
}

class ProductOrderStatusType {
    constructor(value) {
        this.key = Object.keys(productOrderStatusTypes).reduce((result, key) => {
            return result || (productOrderStatusTypes[key] === value ? key : null);
        }, null);
        this.value = value;
        this.name = productOrderStatusTypeNames[value];
    }
}

// eslint-disable-next-line @typescript-eslint/naming-convention
export const Booked = new ProductOrderStatusType(productOrderStatusTypes.Booked);
// eslint-disable-next-line @typescript-eslint/naming-convention
export const Installed = new ProductOrderStatusType(productOrderStatusTypes.Installed);
// eslint-disable-next-line @typescript-eslint/naming-convention
export const Cancelled = new ProductOrderStatusType(productOrderStatusTypes.Cancelled);
// eslint-disable-next-line @typescript-eslint/naming-convention
export const Disconnect = new ProductOrderStatusType(productOrderStatusTypes.Disconnect);
